function _extends() {_extends = Object.assign ? Object.assign.bind() : function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};return _extends.apply(this, arguments);}function ownKeys(e, r) {var t = Object.keys(e);if (Object.getOwnPropertySymbols) {var o = Object.getOwnPropertySymbols(e);r && (o = o.filter(function (r) {return Object.getOwnPropertyDescriptor(e, r).enumerable;})), t.push.apply(t, o);}return t;}function _objectSpread(e) {for (var r = 1; r < arguments.length; r++) {var t = null != arguments[r] ? arguments[r] : {};r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {_defineProperty(e, r, t[r]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));});}return e;}function _defineProperty(obj, key, value) {key = _toPropertyKey(key);if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}function _toPropertyKey(t) {var i = _toPrimitive(t, "string");return "symbol" == typeof i ? i : i + "";}function _toPrimitive(t, r) {if ("object" != typeof t || !t) return t;var e = t[Symbol.toPrimitive];if (void 0 !== e) {var i = e.call(t, r || "default");if ("object" != typeof i) return i;throw new TypeError("@@toPrimitive must return a primitive value.");}return ("string" === r ? String : Number)(t);}var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };} /* eslint-disable max-lines */
/* eslint-disable max-statements */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useState, useRef, useEffect } from 'react';
import { useFieldArray, useForm } from 'react-hook-form';
import ReactPlayer from 'react-player';
import { Icon } from "../../UI";
import { Translate } from "../../I18N";
import { validMediaFile } from "../../Metadata/helpers/validator";
















const propsToConfig = (props) => {
  const config = { url: '', options: { timelinks: {} } };

  let parsedProps = props.config.replace(/\(|\)/g, '').split(',');
  config.url = parsedProps.shift();

  parsedProps = (parsedProps.join(',') || '{}').replace(/&quot;/g, '"');

  try {
    parsedProps = JSON.parse(parsedProps);
  } catch (error) {
    parsedProps = {};
  }

  config.options = parsedProps;

  return config;
};

const formatTimeLinks = (timelinks) =>
Object.keys(timelinks).map((key) => {
  const timeLink = { timeHours: '00', timeMinutes: '00', timeSeconds: '00', label: '' };
  const splitTimes = key.split(':');
  if (splitTimes.length === 2) {
    [timeLink.timeMinutes, timeLink.timeSeconds] = splitTimes;
  } else {
    [timeLink.timeHours, timeLink.timeMinutes, timeLink.timeSeconds] = splitTimes;
  }
  timeLink.label = timelinks[key];
  return timeLink;
});

const MarkdownMedia = (props) => {var _containerRef$current, _containerRef$current2;
  //Given the testing conditions, ref should be declared in this specific order.
  const containerRef = useRef(null);
  const playerRef = useRef(null);

  const [newTimeline, setNewTimeline] = useState({
    timeHours: '',
    timeMinutes: '',
    timeSeconds: '',
    label: ''
  });
  const [errorFlag, setErrorFlag] = useState(false);
  const { options } = propsToConfig(props);
  const originalTimelinks = formatTimeLinks((options === null || options === void 0 ? void 0 : options.timelinks) || {});
  const [playingTimelinkIndex, setPlayingTimelinkIndex] = useState(-1);
  const [isVideoPlaying, setVideoPlaying] = useState(false);
  const [temporalResource, setTemporalResource] = useState();
  const [mediaURL, setMediaURL] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const { control, register, getValues } = useForm({
    defaultValues: { timelines: originalTimelinks }
  });
  const { fields, remove, append } = useFieldArray({
    control,
    name: 'timelines'
  });

  const validMediaUrlRegExp =
  /(^(blob:)?https?:\/\/(?:www\.)?)[-a-zA-Z0-9+&@#/%?=~_|!:,.;]*[-a-zA-Z0-9+&@#/%=~_|]$/;

  const seekTo = (seconds) => {var _playerRef$current;
    const playingStatus = isVideoPlaying;
    (_playerRef$current = playerRef.current) === null || _playerRef$current === void 0 ? void 0 : _playerRef$current.seekTo(seconds);
    setVideoPlaying(playingStatus);
  };

  const timeLinks = (_timelinks) => {
    const timelinks = _timelinks || {};
    return Object.keys(timelinks).map((timeKey, index) => {
      const linkIndex = index;
      const seconds = timeKey.
      split(':').
      reverse().
      reduce((_seconds, n, _index) => _seconds + parseInt(n, 10) * 60 ** _index, 0);

      let displayTime = timeKey;
      if (displayTime.split(':').length === 2) {
        displayTime = `00:${displayTime}`;
      }

      return /*#__PURE__*/(
        _jsx("div", { className: "timelink", title: timelinks[timeKey] }, timeKey + index.toString(), /*#__PURE__*/
        _jsx("b", {
          className: "timelink-icon",
          onClick: () => {
            seekTo(seconds);
            if (linkIndex === playingTimelinkIndex) {
              setVideoPlaying(false);
              setPlayingTimelinkIndex(-1);
            } else {
              setVideoPlaying(true);
              setPlayingTimelinkIndex(linkIndex);
            }
          } }, void 0, /*#__PURE__*/

        _jsx(Icon, { icon: linkIndex === playingTimelinkIndex ? 'pause' : 'play' })
        ), /*#__PURE__*/
        _jsx("div", {
          className: "timelink-time-label",
          onClick: () => {
            seekTo(seconds);
            setPlayingTimelinkIndex(linkIndex);
          } }, void 0, /*#__PURE__*/

        _jsx("b", {}, void 0, displayTime), /*#__PURE__*/
        _jsx("span", {}, void 0, timelinks[timeKey])
        )
        ));

    });
  };

  const updateParentForm = () => {
    if (props.onTimeLinkAdded) props.onTimeLinkAdded(getValues().timelines);
  };

  const appendTimelinkAndUpdateParent = (timelink) => {
    const currentTimelink = timelink || newTimeline;
    append(currentTimelink);
    updateParentForm();
  };

  const renderNewTimeLinkForm = () => /*#__PURE__*/
  _jsx("div", { className: "new-timelink" }, void 0, /*#__PURE__*/
  _jsx("div", { className: "timestamp" }, void 0, /*#__PURE__*/
  _jsx("input", {
    type: "number",
    onChange: (event) => {
      const hours = parseInt(event.target.value || '0', 10);
      setNewTimeline(_objectSpread(_objectSpread({}, newTimeline), {}, { timeHours: hours <= 0 ? '00' : hours.toString() }));
    },
    className: "timestamp-hours",
    placeholder: "00",
    value: newTimeline.timeHours,
    min: "0" }
  ), /*#__PURE__*/
  _jsx("span", { className: "seperator" }, void 0, ":"), /*#__PURE__*/
  _jsx("input", {
    type: "number",
    onChange: (event) => {
      let minutes = parseInt(event.target.value || '0', 10);
      minutes = minutes > 59 ? 59 : minutes;
      setNewTimeline(_objectSpread(_objectSpread({},
      newTimeline), {}, {
        timeMinutes: minutes <= 0 ? '00' : minutes.toString() })
      );
    },
    className: "timestamp-minutes",
    placeholder: "00",
    value: newTimeline.timeMinutes,
    min: "0",
    max: "59" }
  ), /*#__PURE__*/
  _jsx("span", { className: "seperator" }, void 0, ":"), /*#__PURE__*/
  _jsx("input", {
    type: "number",
    onChange: (event) => {
      let seconds = parseInt(event.target.value || '0', 10);
      seconds = seconds > 59 ? 59 : seconds;
      setNewTimeline(_objectSpread(_objectSpread({},
      newTimeline), {}, {
        timeSeconds: seconds <= 0 ? '00' : seconds.toString() })
      );
    },
    className: "timestamp-seconds",
    placeholder: "00",
    value: newTimeline.timeSeconds,
    min: "0",
    max: "59" }
  )
  ), /*#__PURE__*/
  _jsx("input", {
    type: "text",
    onChange: (event) => {
      setNewTimeline(_objectSpread(_objectSpread({}, newTimeline), {}, { label: event.target.value }));
    },
    className: "timestamp-label",
    placeholder: "Enter title",
    value: newTimeline.label }
  ), /*#__PURE__*/
  _jsx("button", {
    type: "button",
    className: "new-timestamp-btn",
    onClick: () => {
      const time = {
        timeHours: newTimeline.timeHours || '00',
        timeMinutes: newTimeline.timeMinutes || '00',
        timeSeconds: newTimeline.timeSeconds || '00',
        label: newTimeline.label
      };

      appendTimelinkAndUpdateParent(time);
      setNewTimeline({ timeHours: '', timeMinutes: '', timeSeconds: '', label: '' });
    } }, void 0, /*#__PURE__*/

  _jsx(Icon, { icon: "plus" })
  )
  );


  const renderSingleTimeLinkInputs = (field, index) => /*#__PURE__*/
  _jsx("div", { className: "new-timelink" }, index, /*#__PURE__*/
  _jsx("div", { className: "timestamp" }, void 0, /*#__PURE__*/
  React.createElement("input", _extends({
    type: "text",
    className: "timestamp-hours",
    placeholder: "00",
    key: `${field.id}hours` },
  register(`timelines.${index}.timeHours`, {
    onChange: (_) => updateParentForm()
  }))
  ), /*#__PURE__*/
  _jsx("span", { className: "seperator" }, void 0, ":"), /*#__PURE__*/
  React.createElement("input", _extends({
    type: "text",
    className: "timestamp-minutes",
    placeholder: "00",
    key: `${field.id}minutes` },
  register(`timelines.${index}.timeMinutes`, {
    onChange: (_) => updateParentForm()
  }))
  ), /*#__PURE__*/
  _jsx("span", { className: "seperator" }, void 0, ":"), /*#__PURE__*/
  React.createElement("input", _extends({
    type: "text",
    className: "timestamp-seconds",
    placeholder: "00",
    key: `${field.id}seconds` },
  register(`timelines.${index}.timeSeconds`, {
    onChange: (_) => updateParentForm()
  }))
  )
  ), /*#__PURE__*/
  React.createElement("input", _extends({
    type: "text",
    className: "timestamp-label",
    placeholder: "Enter title",
    key: field.id },
  register(`timelines.${index}.label`, {
    onChange: (_) => updateParentForm()
  }))
  ), /*#__PURE__*/
  _jsx("button", {
    title: "Remove timelink",
    type: "button",
    className: "delete-timestamp-btn",
    onClick: () => {
      remove(index);
      updateParentForm();
    } }, void 0, /*#__PURE__*/

  _jsx(Icon, { icon: "trash-alt" })
  )
  );


  const renderTimeLinksForm = () => /*#__PURE__*/
  React.createElement(React.Fragment, null,
  fields.map((field, index) =>
  renderSingleTimeLinkInputs(field, index)
  ),
  renderNewTimeLinkForm()
  );


  const config = propsToConfig(props);

  useEffect(() => {
    let url;

    if (config.url.startsWith('/api/files/')) {
      fetch(config.url).
      then(async (res) => {
        if (validMediaFile(res)) {
          return res.blob();
        }
        setErrorFlag(true);
        throw new Error('Invalid file');
      }).
      then((blob) => {
        setErrorFlag(false);
        url = URL.createObjectURL(blob);
        setMediaURL(url);
      }).
      catch((_e) => {}).
      finally(() => {
        setIsLoading(false);
      });
    } else if (config.url.match(validMediaUrlRegExp)) {
      setErrorFlag(false);
      setMediaURL(config.url);
      setIsLoading(false);
    } else {
      if (mediaURL && mediaURL.match(validMediaUrlRegExp) && !temporalResource) {
        setTemporalResource(mediaURL);
      }
      setMediaURL(config.url);
      setIsLoading(false);
    }

    return () => {
      setErrorFlag(false);
      setIsLoading(true);
      URL.revokeObjectURL(url);
      setMediaURL('');
    };
  }, [config.url]);

  useEffect(() => () => {
    if (isVideoPlaying) {
      setVideoPlaying(false);
    }
  });

  useEffect(() => {
    if (
    temporalResource &&
    ReactPlayer.canPlay(temporalResource) &&
    !mediaURL.match(validMediaUrlRegExp))
    {
      setErrorFlag(false);
      setMediaURL(temporalResource);
    }
  }, [temporalResource, mediaURL]);

  const { compact, editing } = props;
  const dimensions = { width: '100%' };
  if (compact) {
    dimensions.height = '100%';
  }

  if (errorFlag) {
    return /*#__PURE__*/(
      _jsx("div", { className: "media-error" }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "This file type is not supported on media fields")
      ));

  }

  return /*#__PURE__*/(
    React.createElement("div", { className: `video-container ${compact ? 'compact' : ''}`, ref: containerRef }, /*#__PURE__*/
    _jsx("div", {}, void 0,
    isLoading ? /*#__PURE__*/
    _jsx("div", { className: "loader" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Loading"), /*#__PURE__*/
    _jsx("div", { className: "bouncing-dots" }, void 0, /*#__PURE__*/
    _jsx("div", { className: "dot" }), /*#__PURE__*/
    _jsx("div", { className: "dot" }), /*#__PURE__*/
    _jsx("div", { className: "dot" })
    )
    ) : /*#__PURE__*/

    React.createElement(ReactPlayer, _extends({
      className: "react-player",
      playing: isVideoPlaying,
      config: {
        facebook: {
          attributes: {
            'data-width': editing ? '' : (_containerRef$current = containerRef.current) === null || _containerRef$current === void 0 ? void 0 : _containerRef$current.clientWidth,
            'data-height': editing ? '300' : (_containerRef$current2 = containerRef.current) === null || _containerRef$current2 === void 0 ? void 0 : _containerRef$current2.clientHeight
          }
        }
      },
      ref: playerRef,
      url: mediaURL },
    dimensions, {
      controls: true,
      onPause: () => {
        setVideoPlaying(false);
      },
      onPlay: () => {
        setVideoPlaying(true);
      },
      onError: (e) => {
        if (e.target.error.message.search(/MEDIA_ELEMENT_ERROR/) === -1) {
          setErrorFlag(true);
        }
      } })
    )

    ),
    !editing && !isLoading && /*#__PURE__*/_jsx("div", {}, void 0, timeLinks(config.options.timelinks)),
    editing && !isLoading && /*#__PURE__*/
    _jsx("div", { className: "timelinks-form" }, void 0, /*#__PURE__*/
    _jsx("button", {
      type: "button",
      className: "add-timelink",
      onClick: () => {var _playerRef$current2;
        const currentTime = (_playerRef$current2 = playerRef.current) === null || _playerRef$current2 === void 0 ? void 0 : _playerRef$current2.getCurrentTime();
        const hours = Math.floor(currentTime / 3600);
        const remainingSeconds = currentTime - hours * 3600;
        const minutes = Math.floor(remainingSeconds / 60);
        const seconds = Math.floor(remainingSeconds % 60);
        const timelink = {
          timeHours: hours < 10 ? `0${hours.toString()}` : hours.toString(),
          timeMinutes: minutes < 10 ? `0${minutes.toString()}` : minutes.toString(),
          timeSeconds: seconds < 10 ? `0${seconds.toString()}` : seconds.toString(),
          label: ''
        };
        appendTimelinkAndUpdateParent(timelink);
      } }, void 0, /*#__PURE__*/

    _jsx(Translate, {}, void 0, "Add timelink")
    ), /*#__PURE__*/
    _jsx("h5", {}, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Timelinks")
    ),
    renderTimeLinksForm()
    ), /*#__PURE__*/

    _jsx("p", { className: "print-view-alt" }, void 0, config.url)
    ));

};


export default MarkdownMedia;